import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputGroup 
} from 'react-bootstrap';

const ShortCircuitGroup = (props) => {
  const [active, setActive] = useState(props.active);
  const [positive_entities, setPositiveEntities] = useState(props.positive_entities);

  useEffect(() => {
    if (props.creatingNewRules === true) {
      setActive(false);
      setPositiveEntities("");
    } else {
      setActive(props.active);
      setPositiveEntities(props.positive_entities);
    }
  }, [props.creatingNewRules]);

  useEffect(() => {
    if (!props.creatingNewRules) {
      setActive(props.active);
    }
  }, [props.active]);

  useEffect(() => {
    if (!props.creatingNewRules) {
      setPositiveEntities(props.positive_entities);
    }
  }, [props.positive_entities]);

  useEffect(() => {
    props.update({
      active: active,
      positive_entities: positive_entities
    });
  }, [active, positive_entities]);

  return (
    <InputGroup size='sm' className="mb-3">
      <InputGroup.Prepend>
        <InputGroup.Checkbox 
          checked={active}
          onChange={(evt) => setActive(evt.target.checked)} 
        />
        <InputGroup.Text>Short circuit if</InputGroup.Text>
      </InputGroup.Prepend>
      <FormControl 
        value={positive_entities}
        onChange={(evt) => setPositiveEntities(evt.target.value)}
      />
      <InputGroup.Append>
        <InputGroup.Text> sensitive elements found</InputGroup.Text>
      </InputGroup.Append>
    </InputGroup>
  );
}

export default ShortCircuitGroup
